import React, { useEffect, useRef, useState } from "react";
import { Footer } from "./Footer";

/**
 * Defers Footer mount until the bottom sentinel scrolls within ~1500px of
 * the viewport. This avoids a ~1-viewport CLS that would otherwise be
 * recorded when Footer paints under a short Suspense fallback and later
 * gets pushed down by the resolved lazy page chunk.
 */
export function DeferredFooter({ lang }: { lang: "es" | "en" }) {
  const [show, setShow] = useState(false);
  const sentinelRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    if (!sentinelRef.current) return;
    const el = sentinelRef.current;
    const io = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          setShow(true);
          io.disconnect();
        }
      },
      { rootMargin: "1500px 0px 1500px 0px" },
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return (
    <>
      <div ref={sentinelRef} aria-hidden="true" style={{ height: 1 }} />
      {show ? <Footer lang={lang} /> : null}
    </>
  );
}